import './AnnouncementBar.css'
import { useOffers } from '../hooks/useSiteData'

export default function AnnouncementBar() {
  const offers = useOffers()
  if (!offers.length) return null // nothing added in the admin yet

  // One "set" of offers. It is rendered twice so the track can scroll by
  // exactly -50% and loop seamlessly. Repeat the list inside a set when there
  // are only a few offers so the set is always wider than the screen.
  const repeats = Math.max(1, Math.ceil(6 / offers.length))
  const set = Array.from({ length: repeats }, () => offers).flat()

  return (
    <div className="announce" role="status" aria-label="Offers">
      <div className="announce__track">
        {[0, 1].map(copy => (
          <div className="announce__set" key={copy} aria-hidden={copy === 1}>
            {set.map((text, i) => (
              <span className="announce__item" key={i}>{text}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}